<template>
  <div class="slide-editor">
    <div class="layout-content">
      <Thumbnails class="layout-content-left" />
      <div class="layout-content-center">
        <CanvasTool class="center-top" v-if="!slideNanoid"/>

        <Canvas class="center-body" :style="{ height: `calc(100% - 32px)` }"/>
      </div>
      <Toolbar v-if="!slideNanoid" class="layout-content-right"/>
    </div>
  </div>

  <SelectPanel v-if="showSelectPanel && !slideNanoid"/>

</template>

<script lang="ts" setup>
import {computed, ref, onMounted, onBeforeMount} from 'vue'
import {storeToRefs} from 'pinia'
import {useMainStore, useWidgetStore} from '@/store'
import useGlobalHotkey from '@/hooks/useGlobalHotkey'
import usePasteEvent from '@/hooks/usePasteEvent'
import useMicroservice from '@/hooks/useMicroservice';


import EditorHeader from './EditorHeader/index.vue'
import Canvas from './Canvas/index.vue'
import CanvasTool from './CanvasTool/index.vue'
import Toolbar from './Toolbar/index.vue'
import SelectPanel from './SelectPanel.vue'
import Thumbnails from './Thumbnails/index.vue'
import {Modal} from 'ant-design-vue'

const mainStore = useMainStore()
const {dialogForExport, showSelectPanel, slideNanoid, calculatorId} = storeToRefs(mainStore)
const widgetStore = useWidgetStore()
const {activeType} = storeToRefs(widgetStore)
const closeExportDialog = () => mainStore.setDialogForExport('')


const remarkHeight = ref(40)

const api = useMicroservice()
onMounted(() => {
      api.savePresentation()
})

const setColor = computed(() => {
  if (activeType.value === 'none') {
    return '$lightGray'
  } else {
    return '#fff'
  }
})

const setBorder = computed(() => {
  if (activeType.value === 'none') {
    return 0
  } else {
    return `1px solid #eee`
  }
})

useGlobalHotkey()
usePasteEvent()
</script>

<style lang="scss" scoped>
.slide-editor {
  flex-grow: 1;
  overflow-x: scroll;
  overflow-y: hidden;
}

.layout-header {
  height: 32px;
}

.layout-content {
  height: calc(100%);
  display: flex;
  min-width: 1366px;
}

.layout-content-left {
  width: 160px;
  height: 100%;
  flex-shrink: 0;
}

.layout-content-center {
  width: calc(100% - 360px);

  .center-top {
    height: 32px

  }
}

.layout-content-right {
  width: 375px;
  height: 100%;
}


::-webkit-scrollbar {
  display: block;
}

::-webkit-scrollbar {
  background-color:#fff;
  width:16px
}

/* background of the scrollbar except button or resizer */
::-webkit-scrollbar-track {
  background-color:#fff
}
::-webkit-scrollbar-track:hover {
  background-color:#f4f4f4
}

/* scrollbar itself */
::-webkit-scrollbar-thumb {
  background-color:#babac0;
  border-radius:16px;
  border:5px solid #fff
}
::-webkit-scrollbar-thumb:hover {
  background-color:#a0a0a5;
  border:4px solid #f4f4f4
}
</style>
